import { useEffect, useState } from "react";
import { setInitialized, setSubscriptions } from "@store/subscriptionSlice";
import { SubscriptionService } from "@service/subscription/subscription.service";
import { RevenuecatSubscriptionService } from "@service/subscription/revenuecat-subscription.service";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";

export const useInitSubscription = () => {
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const [service] = useState<SubscriptionService>(
    RevenuecatSubscriptionService.instance,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!accountId) {
      return;
    }
    (async () => {
      if (await service.init(accountId)) {
        dispatch(setSubscriptions(service.getSubscriptions()));
        dispatch(setInitialized(true));
      }
    })();

    return () => {
      service.destroy();
      dispatch(setInitialized(false));
    };
  }, [service, accountId, dispatch]);
};
